import React from "react";
import { NoDataFound } from "@public/ui-toolkit";
import moment from "moment";

const FeedTable = ({ feedTableData, message }) => {
  return feedTableData?.length ? (
    feedTableData?.map((news) => {
      return (
        <div key={news.id} className="news-feed">
          <div className="newsfeed-row">
            <div className="newsfeed-img">
              <img src={news?.userProfileImage} alt="" />
            </div>
            <div className="newsfeed-content">
              <div>
                <span className="newsfeed-date">
                  <h6 style = {{color:'#000'}}>{news?.tenantName}</h6>
                </span>
                <span className="text-blue">
                  {moment(news?.postedDate)?.format("MMMM Do YYYY")}
                </span>
              </div>
              <p dangerouslySetInnerHTML={{ __html: news?.description }}></p>
            </div>
          </div>
        </div>
      );
    })
  ) : (
    <NoDataFound />
  );
};

export default FeedTable;
